import styled from "styled-components";

export const SessionTimerValueDefaultBox = styled.div`
    white-space: nowrap;
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        display: inline-block;
    }
`;

export const InLobbySessionTimerValueBox = SessionTimerValueDefaultBox;